module.exports = __webpack_public_path__ + "static/media/deployed1.173a15e6.jpg";